import React from "react";
import './InvestMenu.css';
import InvestMenuElement from "./InvestMenuElement/InvestMenuElement";
function InvestMenu(props) {
    return (
        <div className={props.styleMain}>
                <InvestMenuElement ssilka='/' label={props.Name01} active={props.active} inactive={props.inactive}  lang={props.lang}/>
                <InvestMenuElement ssilka='/terminals/web' label={props.Name02} active={props.active} inactive={props.inactive} lang={props.lang}/>
                <InvestMenuElement ssilka='/Invest/tonext' label={props.Name03} active={props.active} inactive={props.inactive} lang={props.lang}/>
                <InvestMenuElement ssilka='/Invest/FAQ' label={props.Name04} active={props.active} inactive={props.inactive} lang={props.lang}/>
                <InvestMenuElement ssilka='/Invest/registration' label={props.Name05} active={props.active} inactive={props.inactive} lang={props.lang}/>
        </div>
    )}

export default InvestMenu